import clsx from "clsx"

import { CommonInput } from "@/components/common/element/fields/CommonInput"
import { ICompanyBank } from "@/types/company/IFullCompanyDto"
import { ISwift } from "@/types/dict/ISwift"
import { SwiftPicker } from "@/components/common/element/fields/SwiftPicker"
import { CurrencyPicker } from "@/components/common/element/fields/CurrencyPicker"

import type { IErrorModel } from "@/types/error/IErrorModel"
import type { FC } from "react"

import banksStyle from "../style.module.scss"

type Props = {
  bank?: ICompanyBank | null
  setBank: (data: ICompanyBank) => void
  errors?: IErrorModel
}

export const BanksForm: FC<Props> = ({ bank, setBank, errors }) => {
  const changeSwift = (swift: ISwift | undefined) => {
    if (swift?.bank_name) {
      setBank({ ...bank, swift: swift.swift_code, name: swift.bank_name })
    } else if (swift) {
      setBank({ ...bank, swift: swift.swift_code })
    }
  }

  const changeCurrency = (currency: string) => {
    setBank({ ...bank, currency: currency })
  }

  return (
    <div className={clsx("form-block-popup", banksStyle.createForm)}>
      <CommonInput
        typeName={"text"}
        label={"Название"}
        placeholder={"PT GAS"}
        name={"name"}
        value={bank?.name}
        errorModel={errors}
        _callback={e => setBank({ ...bank, name: e })}
      />
      <SwiftPicker
        label={"SWIFT банка"}
        name={"swift"}
        value={bank?.swift}
        errorModel={errors}
        _callback={changeSwift}
      />
      <CommonInput
        typeName={"text"}
        label={"Номер счета"}
        placeholder={"23823044"}
        name={"accountNumber"}
        value={bank?.accountNumber}
        errorModel={errors}
        _callback={e => setBank({ ...bank, accountNumber: e })}
      />
      <CurrencyPicker
        label={"Валюта счета"}
        name={"currency"}
        errorModel={errors}
        initValue={bank?.currency}
        _callback={changeCurrency}
      />
    </div>
  )
}
